<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                color="primary"
                class="float-left mb-2 ml-3"
                @click="rowClickedCreate"
                >Create New POS</CButton
              >
              <CButton
                color="primary"
                class="float-left mb-2 ml-3"
                @click="handleClickBulk"
              >
              Bulk Import POS
              </CButton>
            </CCol>
            <!-- Bulk import POS -->
            <div class="form-create-bulk-pos" v-if="showFormCreate">
              <CCard>
                <CCardHeader>
                  <CRow>
                    <CCol sm="10" class="">
                      <h5 id="traffic" class="card-title ml-3 mb-0">
                        Upload Berkas
                      </h5>
                    </CCol>
                    <CCol
                      sm="2"
                      class="d-flex justify-content-end"
                      @click="hideFormCreate">
                        <CIcon type="button" name="cil-x-circle"/>
                    </CCol>
                  </CRow>
                </CCardHeader>
                  <CCardBody class="border-bottom-0">
                    <CRow>
                      <CCol sm="12" class="ml-3">
                        <h5 id="traffic" class="card-title mb-3">
                          Create New POS
                        </h5>
                      </CCol>
                      <CCol sm="12" class="ml-3">
                        <div class="label-input-file pt-1">
                          <label for="label-file-wording" class="btnd">Pilih Berkas : </label>
                          <label class="file-name-inputs">{{ fileName }}</label>
                        </div>
                      </CCol>
                      <CCol sm="12">
                        <input
                          @change="setFile($event)"
                          type="file"
                          id="uploads"
                          class="file"
                          accept=".xlsx"
                        />
                      </CCol>
                    </CRow>
                  </CCardBody>
                  <CRow class="form-group">
                    <CCol :col="6">
                      <CButton
                        @click="exportTemplate(`Bulk Import POS - ${formatDate(new Date())}`)"
                        color="primary"
                        class="float-left btn-member-upload mt-2 mb-2"
                      >
                        Download Template
                      </CButton>
                    </CCol>
                    <CCol :col="6" class="">
                      <CButton
                        @click="bulkInsert()"
                        color="primary"
                        class="float-right btn-username-upload mt-2 mb-2"
                      >
                        Upload
                      </CButton>
                    </CCol>
                  </CRow>
                </CCard>
              </div>
            <!-- end Bulk Import POS -->
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-0 mr-2"
                    placeholder="Search By POS Name"
                    v-model="searchContent"
                    @input="searchPOS('')"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="100"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #action="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-1"
                    @click="rowClicked(data.item.npos_id)"
                    >Detail</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div class="pagination-btn-refresh" @click="searchPOS('REFRESH')">
              Refresh
            </div>
            <div class="pagination-btn-back" @click="searchPOS('BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div class="pagination-btn-next" @click="searchPOS('NEXT')">
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import XLSX from 'xlsx'
import Swal from 'sweetalert2';

export default {
  name: "Province",
  data() {
    return {
      items: [],
      searchContent: "",
      fields: [
        { key: "npos_id", label: "ID" },
        { key: "latter_code", label: "Latter Code" },
        { key: "npos_name", label: "POS Name" },
        { key: "address", label: "Alamat" },
        { key: "contact_number", label: "Kontak Number" },
        { key: "latlong", label: "Latlong" },
        { key: "action", label: "Action" },
      ],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      showFormCreate: false,
      fileName: "",
      fileData: "",
      templateMemberPOS: [
        {
          latter_code: '',
          npos_name: '',
          sub_district_id: '',
          address: '',
          contact_number: '',
          latlong: '',
          status: ''
        },
      ],
    };
  },
  mounted() {
    this.authentication();
    this.searchPOS("");
  },

  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },

    searchPOS(action) {
      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }

      axios
        .get(
          `${this.domain}/v1/pos/list/data?page=${this.activePage}&per_page=100&q=${this.searchContent}`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.data.length > 0) {
            if (this.activePage > 1) {
              window.scrollTo(0, 0);
            }
            this.items = response.data.data;
          } else if (action === "NEXT") {
            this.activePage = this.activePage - 1;
          } else if (response.data.data.length === 0 && action === "") {
            this.items = response.data.data;
          }
        })
        .catch(() => {});
    },
    rowClickedCreate() {
      this.$router.push({ path: `/agent/network/pos/create` });
    },
    rowClicked(event) {
      this.$router.push({ path: `/agent/network/pos/detail/${event}` });
    },
    handleClickBulk() {
      this.fileName = "";
      this.fileData = "";
      this.showFormCreate = !this.showFormCreate;
    },
    hideFormCreate() {
      this.fileName = "";
      this.fileData = "";
      this.showFormCreate = false;
    },
    setFile(event) {
      const fullPath = event.target.value
      if(fullPath) {
        const startIndex =
          fullPath.indexOf('\\') >= 0
          ? fullPath.lastIndexOf('\\')
          : fullPath.lastIndexOf('/')
        this.fileName = fullPath.substring(startIndex + 1)

        const extension = this.fileName.split('.')
        if(extension[extension.length -1] !== 'xlsx') {
          this.fileName = ''
          this.fileData = ''
          this.responseMessage('error', 'Format file harus excel')
        } else {
          this.fileData = event.target.files[0]
        }
      }
    },
    exportTemplate(payload){
      var memberPOS = XLSX.utils.json_to_sheet(this.templateMemberPOS);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, memberPOS, "Sheet1");
      XLSX.writeFile(wb, payload + ".xlsx");
    },
    bulkInsert() {
      const form = new FormData()
      form.append('pos_file', this.fileData)
      axios.post(
        `${this.domain}/v1/import/pos`, form , {
          headers: {
            Authorization: this.token,
            'Content-Type': 'application/json'
          },
        }
      )
      .then(() => {
        Swal.fire({
          icon: "success",
          title: 'Successfully Upload',
          showConfirmButton: false,
          timer: 2000,
        });
        this.showFormCreate = false
      })
      .catch((err) => {
        if(!this.fileData) {
          this.responseMessage('error', 'Upload data terlebih dahulu!')
        }
        Swal.fire({
            icon: "error",
            title: err.response.data.message.id,
            showConfirmButton: false,
            timer: 2000,
          });
      })
    },
    formatDate(dateNow) {
      const str = dateNow.toString().split(' ')
      const date = str[2]
      const year = str[3]
      const month = dateNow.getMonth()
      return `${date}${month.length === 2 ? month : '0'+month}${year}`
    },
    responseMessage(icon, message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: icon,
        title: message,
      });
    },
  },
};
</script>

<style scoped>
@import url("../../agent_registration/Agent.css");
</style>
